export default __webpack_public_path__ + "static/media/empty-trip.8f191e42.svg";